import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

const getInventoryMembers = createAsyncThunk(
  'manage/inventoryMembers',
  async (
    {
      page,
      size,
      search,
      sortBy,
      asc,
      groupId,
      warehouseId,
      excludeId,
      all,
      from,
      to,
      userId,
      projectId,
    },
    { rejectWithValue, getState },
  ) => {
    try {
      let url = `${apiEndpoint}/api/v1/bussines/inventorymembers?page=${page}&size=${size ?? 10}`
      if (search) {
        url += `&search=${search}`
      }
      if (sortBy) {
        url += `&sortby=${sortBy}&sortdir=${asc}`
      }
      // if (warehouseId) {
      //   url += `&warehouseId=${warehouseId}`
      // }
      if (groupId) {
        url += `&groupId=${groupId}`
      }
      if (excludeId) {
        url += `&excludeId=${excludeId}`
      }
      if (from && to) {
        url += `&from=${from}&to=${to}`
      }
      if (userId && userId !== '') {
        url += `&userId=${userId}`
      }
      if (projectId && projectId !== '') {
        url += `&projectId=${projectId}`
      }
      if (all) {
        url += `&all=${all}`
      }

      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getPackingDetail = createAsyncThunk(
  'manage/packingDetailMembers',
  async ({ page, search, sortBy, asc, id }, { rejectWithValue, getState }) => {
    try {
      let url = `${apiEndpoint}/api/v1/bussines/inventorygroupsmembers/${id}?page=${page}&size=10`
      if (search) {
        url += `&search=${search}`
      }
      if (sortBy) {
        url += `&sortby=${sortBy}&sortdir=${asc}`
      }

      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getGroupInventory = createAsyncThunk(
  'manage/groupInventoryMembers',
  async (
    { page, size, search, sortBy, asc, warehouseId },
    { rejectWithValue, getState },
  ) => {
    try {
      let url = `${apiEndpoint}/api/v1/bussines/inventorygroupsmembers?page=${page}&size=${size ?? 10}`
      if (search) {
        url += `&s=${search}`
      }
      if (sortBy) {
        url += `&sortby=${sortBy}&sortdir=${asc}`
      }
      if (warehouseId) {
        url += `&warehouseId=${warehouseId}`
      }

      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(url, config)

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const fetchInventoryGroups = createAsyncThunk(
  'manage/fetchInventoryGroupsMembers',
  async (
    { page = 0, size, search, sortBy, asc, parentGroupId },
    { rejectWithValue, getState },
  ) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      let url = `${apiEndpoint}/api/v1/bussines/inventorygroupsmembers?page=${page}&size=${size ?? 10}`

      if (search) {
        url += `&s=${search}`
      }
      if (sortBy) {
        url += `&sortby=${sortBy ?? 'updatedAt'}&sortdir=${asc ?? 'desc'}`
      }
      if (parentGroupId) {
        url += `&parentGroupId=${parentGroupId}`
      }

      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getRegisteredFarmers = createAsyncThunk(
  'manage/registeredFarmers',
  async ({ page = 0, size = 10 }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const url = `${apiEndpoint}/api/v2/bussines/group/register-farmer?size=${size}&page=${page}&status=JOIN`
      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getInventorySummary = createAsyncThunk(
  'manage/inventorySummary',
  async (
    {
      page,
      size,
      search,
      sortBy,
      sortDir,
      groupId,
      warehouseId,
      dateFrom,
      dateTo,
      method,
      userId,
      forpage,
      all,
    },
    { rejectWithValue, getState },
  ) => {
    try {
      const requestSize = size ?? 10
      const isChunked = requestSize > 50
      const chunkSize = 50

      const buildUrl = (p, s) => {
        let u = `${apiEndpoint}/api/v1/bussines/inventory/summary?page=${p}&size=${s}`
        if (sortBy) {
          u += `&sortby=${sortBy}`
        }
        if (sortDir) {
          u += `&sortdir=${sortDir}`
        }
        if (warehouseId) {
          u += `&warehouseId=${warehouseId}`
        }
        if (groupId) {
          u += `&groupId=${groupId}`
        }
        if (dateFrom && dateTo) {
          u += `&from=${dateFrom}&to=${dateTo}`
        }
        if (method) {
          u += `&method=${method}`
        }
        if (search) {
          u += `&search=${encodeURIComponent(search)}`
        }
        if (userId) {
          u += `&userId=${userId}`
        }
        if (forpage) {
          u += `&forpage=${forpage}`
        }
        if (all) {
          u += `&all=${all}`
        }
        return u
      }

      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      if (isChunked) {
        const firstUrl = buildUrl(0, chunkSize)
        const { data: firstData } = await axios.get(firstUrl, config)

        let mergedItems = firstData?.items ? [...firstData.items] : []
        const totalItems = firstData?.totalItems ?? 0

        if (totalItems > chunkSize) {
          const totalPages = Math.ceil(totalItems / chunkSize)
          const promises = []
          for (let p = 1; p < totalPages; p++) {
            const chunkUrl = buildUrl(p, chunkSize)
            promises.push(axios.get(chunkUrl, config))
          }
          const results = await Promise.all(promises)
          results.forEach((res) => {
            if (res?.data?.items) {
              mergedItems = mergedItems.concat(res.data.items)
            }
          })
        }

        return {
          ...firstData,
          items: mergedItems,
        }
      } else {
        const url = buildUrl(page ?? 0, requestSize)
        const { data } = await axios.get(url, config)
        return data
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export {
  fetchInventoryGroups,
  getGroupInventory,
  getInventoryMembers,
  getInventorySummary,
  getPackingDetail,
  getRegisteredFarmers,
}
